<template>
  <!-- Kontener pojedynczego filtra: flexowy układ w wierszu -->
  <div class="filter"
       :class="isSG ? 'filter--no-border' : 'filter--border'">
    <!-- Etykieta filtra: nazwa przetłumaczona za pomocą $t -->
    <div class="name">{{ name }}</div>
    <!-- Symbol operatora (np. '=', '>='): wyświetlany po prawej stronie nazwy -->
    <span class="symbol">{{ symbol }}</span>
    <!-- Pole input:
         - name atrybut odpowiada kluczowi w store.filters
         - v-model.lazy wiąże wartość dwukierunkowo i zapisuje po zmianie
         - wartość trafia do store przez watcher w setup -->
    <input
      :name="fieldName"
      v-model.lazy="value"
      type="text"
    />
  </div>
</template>

<script>
import { watch, ref } from "vue";                       // Import reactive i watch z Composition API
import { useArchivalFiltersStore } from "../../stores/archivalFilters"; // Import store Pinia dla filtrów
import { isNOSG } from "@/config/appVersion";

export default {
  name: "SingleFilter",                                 // Nazwa komponentu
  props: ["name", "symbol", "fieldName", "isSG"],            // Właściwości przekazywane przez rodzica
  setup(props) {
    // Uzyskanie instancji store z filtrami archiwalnymi
    const filtersStore = useArchivalFiltersStore();

    if (
      props.fieldName === "similarity" &&
      isNOSG &&
      (filtersStore.filters[props.fieldName] === undefined || filtersStore.filters[props.fieldName] === "")
    ) {
      filtersStore.addItem(props.fieldName, 1);
    }
    
    // Inicjalizacja ref z wartością istniejącą w store lub pustym stringiem
    const value = ref(
      filtersStore.filters[props.fieldName] ?? ""
    );

    // Funkcja zapisująca nową wartość do store
    const saveValue = (newVal) => {
      filtersStore.addItem(props.fieldName, newVal);
    };

    // Obserwator zmian value: wywołuje saveValue przy każdej zmianie
    watch(value, (newVal) => {
      saveValue(newVal);
    });

    // Zwracamy ref i store do użycia w template
    return { value, filtersStore };
  },
};
</script>

<style scoped>
/* Wiersz filtra: etykieta — operator — pole. Wysokość i obramowanie pola
   pochodzą z design-system.css, tutaj tylko układ wiersza.

   Wiersz wpina się w siatkę kolumn `.vehicle-half--grid` (ArchivalVehicleData.vue)
   przez `subgrid`, zamiast rozstawiać elementy własnym flexem. Tylko tak kolumna
   operatora ma tę samą szerokość co w wierszach zakresowych, a pole zaczyna się
   równo z polem „od" pod spodem. Odstępy kolumn dziedziczymy z rodzica. */
.filter {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  align-items: center;
  min-width: 0;
  padding: var(--spacing-sm) 0;
}

/* warianty zależne od isSG */
.filter--border {
  border-bottom: 1px solid var(--border-subtle);
}
.filter--no-border {
  border-bottom: none;
}

.filter:last-child {
  border-bottom: 0;
}

/* Operator porównania (=, >=) — dyskretny znacznik przy polu. Bez własnej
   szerokości: wyznacza ją wspólna kolumna siatki. */
.symbol {
  text-align: center;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}

/* Pole zajmuje wszystko od kolumny pierwszego pola do końca wiersza, czyli
   dokładnie obszar „pole od + operator do + pole do" z wierszy zakresowych. */
input {
  grid-column: 3 / -1;
  width: auto;
  min-width: 0;
  text-align: center;
  text-transform: uppercase;
}
</style>
